import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { slug: String };

  show(event) {
    if (event?.target.closest('[data-replayable-effect-target="overlay"]')) return;

    const modalId = `undistractorExplainerModal-${this.slugValue}`;
    const modalElement = document.getElementById(modalId);
    const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
    modal.show();
  }
}
